import { render, staticRenderFns } from "./InvoiceExpense.vue?vue&type=template&id=9d4e4628&scoped=true&"
import script from "./InvoiceExpense.vue?vue&type=script&lang=js&"
export * from "./InvoiceExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4e4628",
  null
  
)

export default component.exports